import { LitElement, css, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { ProductSearchResult } from '../api/models';
import { Layout } from '../state/pages';
import { styles as sharedStyles } from '../styles/shared-styles';

import '@shoelace-style/shoelace/dist/components/animation/animation';
import '@shoelace-style/shoelace/dist/components/animation/animations';
import '@shoelace-style/shoelace/dist/components/button/button';
import '@shoelace-style/shoelace/dist/components/badge/badge';
import '@shoelace-style/shoelace/dist/components/card/card';
import '@shoelace-style/shoelace/dist/components/icon-button/icon-button';
import '@shoelace-style/shoelace/dist/components/rating/rating';
import '@shoelace-style/shoelace/dist/shoelace.js';

import { AddToListEvent, NavigateEvent, RemoveFromListEvent } from '../events';
import { switchLayout } from '../media-query';

export enum MODE {
  ROW,
  GRID
}

@customElement('product-searchresult')
export class ProductSearchresultComponent extends LitElement {

  @property({ attribute: false, state: true, type: Object })
  private layout: Layout = Layout.PHONE;

  @property({ attribute: false, type: Object })
  productSearchResult: ProductSearchResult | null = null;

  @property({ attribute: true, type: Boolean })
  favorite: boolean = false;


  @property({ attribute: true, type: Boolean })
  mode: MODE = MODE.GRID;

  static styles = [
    sharedStyles,
    css`
    .product-button {
      transition: transform var(--sl-transition-medium);
      padding: 2px;
      background-color: white;
      border: 1px solid var(--sl-color-neutral-100);
      border-radius: var(--sl-border-radius-medium);     
    }  
    
    .product-button.promo {
      // border-color: var(--sl-color-danger-800);
    }
    
    .product-button.phone {
      font-size: var(--sl-font-size-x-small);
      border-width: var(--sl-spacing-3x-small);
    }  
    
    .product-button.tablet {
      font-size: var(--sl-font-size-x-small);
      border-width:var(--sl-spacing-3x-small);
    }  
    
    .product-button.laptop {
      font-size: var(--sl-font-size-small);
      border-width:var(--sl-spacing-3x-small);
    }  
    
    .product-button.desktop {
      font-size: var(--sl-font-size-small);
      border-width:var(--sl-spacing-2x-small);
    }  
    
    .product-button:hover, .product-button:focus, .product-button:active {
      cursor: pointer;
      border-color: var(--sl-color-primary-600);
    }
    .product-button.promo:hover, .product-button.promo:focus, .product-button.promo:active {
      border-color: var(--sl-color-danger-600);
    }
    .product-grid {
      display: grid;
      grid-template-columns: 40% 60%;
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
    }

    .product-item1 {
      grid-column: 1;
      grid-row: 1;
      position: relative;
    }

    .product-button.phone .product-item1 {
      grid-row: 1 / span 2;
    }

    .product-item2 {
      grid-column: 2;
      grid-row: 1;
      position: relative;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      text-align: center
    }

    .product-item2 > span.prices {
      padding: 10px;
      margin: auto;
      height: 100%;
    }

    .product-item3 {
      grid-column: 1 / span 2;
      grid-row: 2;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .product-button.phone .product-item3 {
      grid-column: 2;
    }
    .product-image {
      width: 100%;
      height: 100%;
      object-fit: cover; /* or contain, depending on your needs */
      max-width: 100%;
      max-height: 100%;
    }
    
    .shop-image {
      position: absolute;
      top: 3px;
      left: 3px;
      z-index: 1;
    }
    
    
    sl-icon-button.favorite {
      position: absolute; /* Position the icon-button absolutely */
      top: -5px; /* Adjust top position as needed */
      right: -5px; /* Adjust right position as needed */
      z-index: 1; /* Ensure the icon-button appears above the image */
    }    
    
    sl-icon-button.favorite::part(base) {
      color: var(--sl-color-danger-600);
      transition: transform 0.3s ease;
    }
    
    sl-icon-button.favorite::part(base):hover,
    sl-icon-button.favorite::part(base):focus,
    sl-icon-button.favorite::part(base):active {
      color: var(--sl-color-danger-600);
      transform: scale(1.2); 
    }
    sl-icon-button.favorite.selected::part(base) {
      color: var(--sl-color-danger-600);
    }
    
    .product-name {
        height: 40px;
        overflow: hidden;
        text-overflow: ellipsis;
        font-family: var(--sl-font-sans);
        // font-weight: var(--sl-font-weight-bold);
        font-size: var(--sl-font-size-medium);
        text-wrap: pretty;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: var(--sl-color-primary-600);
    }

    .product-grid.phone .product-name {
        height: 60px;
    }

    .badge-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--sl-spacing-2x-small);
      height: 100%;
      margin: auto 0; /* This centers the content vertically */
      padding: var(--sl-spacing-x-small);
    }

    .badge-group {
      display: flex;
      gap: var(--sl-spacing-2x-small);
      justify-content: center;
      align-items: center;
    }
      
    .price-text {
      white-space: nowrap; /* Prevents text wrapping */
      overflow: hidden;
      text-overflow: ellipsis; /* Truncate text with ellipsis if it overflows */
      font-weight: var(--sl-font-weight-bold);
      font-size: var(--sl-font-size-large);
      font-family: var(--sl-font-mono);
      color: var(--sl-color-neutral-800);
      margin: auto;
    }    

    .price-text.promo {
      color: var(--sl-color-danger-500);
    }

    .price-text.original {
      color: var(--sl-color-neutral-400);
      text-decoration: line-through;
      font-size: var(--sl-font-size-medium);
    }
    
    .product-button.phone .price-text.original,  .product-button.laptop .price-text.original {
      font-size: var(--sl-font-size-x-small);
    }

    .price-text.unit-price {
      color: var(--sl-color-neutral-500);
      font-size: var(--sl-font-size-medium);
    }

    .product-button.phone .price-text.unit-price,  .product-button.laptop .price-text.unit-price {
      font-size: var(--sl-font-size-x-small);
    }

    sl-badge.price-text.quantity {
      font-size: var(--sl-font-size-2x-small);
      font-family: var(--sl-font-mono);
    }

    .product-button.phone .favorite {
      font-size: var(--sl-font-size-medium);
    }
    .product-button.tablet .favorite {
      font-size: var(--sl-font-size-large);
    }
    .product-button.laptop .favorite {
      font-size: var(--sl-font-size-x-large);
    }
    .product-button.desktop .favorite {
      font-size: var(--sl-font-size-x-large);
    }

    `,


  ];




  productClassList(): string {
    let ret = switchLayout(this.layout, "product-button phone", "product-button tablet", "product-button laptop", "product-button desktop");
    if (this.productSearchResult!.promo) {
      ret = ret + " promo";
    }
    return ret;
  }

  // in case of error loading the product image
  setPlaceholderImage(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.removeEventListener('error', this.setPlaceholderImage);
    imgElement.src = '/img/no-image.jpg'; // Replace with your fallback image URL
  }

  renderPromo() {
    return html`<div class="price-text quantity promo">
        <span>
          <sl-badge variant="danger" pill>
              <sl-format-number type="percent" value=${this.productSearchResult?.promoPercentage || 0.0}></sl-format-number>
          </sl-badge>
        </span>
        <span>
          <sl-badge variant="success" class="price-text quantity" pill>
          ${this.productSearchResult!.promoQuantity}
          </sl-badge>
        </span>
    </div>`;
  }

  renderUnitPrice() {
    if (!this.productSearchResult?.unitPrice) return nothing;
    return html`
    <div class="badge-group">
        <sl-badge variant="primary" class="price-text unit-price" pill>
          ${this.productSearchResult!.unitPrice}
        </sl-badge>
        ${this.productSearchResult.quantity && this.productSearchResult.quantity.length ? html`
          <sl-badge variant="neutral" class="price-text unit-price" pill>
        ${this.productSearchResult.quantity}
        </sl-badge>` : nothing}
        
    </div>`
  }

  renderPrice() {
    if (!this.productSearchResult!.price) return nothing;
    if (!this.productSearchResult?.promoPrice) {
      // NOT PROMO
      return html`
      <div>
        <div class="price-text">
            <sl-format-number type="currency" currency="EUR" value="${this.productSearchResult?.price}" lang="nl">
            </sl-format-number>
        </div>
      </div>
      <hr/>
      <div class="badge-container">
        ${this.renderUnitPrice()}
      </div>
      `;
    } else {
      // PROMO
      return html`
      <div>
          <span class="price-text promo">
              <sl-format-number type="currency" currency="EUR" value="${this.productSearchResult!.promoPrice}" lang="nl">
              </sl-format-number>
          </span>
          <span class="price-text original">
              <sl-format-number type="currency" currency="EUR" value="${this.productSearchResult?.originalprice ? this.productSearchResult?.originalprice : this.productSearchResult?.price}" lang="nl">
              </sl-format-number>
          </span>        
       </div>
       <hr/>
       <div class="badge-container">
        ${this.renderUnitPrice()}
        <div class="badge-group">
          <span>
            <sl-badge variant="danger" pill>
                <sl-format-number type="percent" value=${this.productSearchResult?.promoPercentage || 0.0}></sl-format-number>
            </sl-badge>
          </span>
          <span>
            <sl-badge variant="success" class="price-text quantity" pill>
            ${this.productSearchResult!.promoQuantity}
            </sl-badge>
          </span>
        </div>
      </div>
      `;
    }
  }

  render() {
    if (!this.productSearchResult) {
      return nothing;
    }
    return html`
            <a href="${this.productSearchResult.productUrl}" style="display: none;"></a>
            <div class=${this.productClassList()} @click=${this.touchHandler}>
            <div class=${switchLayout(this.layout, "product-grid phone", "product-grid tablet", "product-grid laptop", "product-grid desktop")}>
                <div class="product-item1">
                    <img @error=${this.setPlaceholderImage} class="product-image" loading="lazy" src="${this.productSearchResult.imageUrl}"/>
                    <img class="shop-image" width="${switchLayout(this.layout, 40, 40, 40, 40)}px" src="/img/${this.productSearchResult.shop}.svg">
                </div>
                <div class="product-item2">
                    <sl-animation name="rubberBand" duration="2500" iterations="1" class="animate">
                    <sl-icon-button id="favorite"
                        class="${this.favorite ? 'favorite selected' : 'favorite'}"
                        name=${this.favorite ? 'heart-fill' : 'heart'}
                        label=${this.favorite ? 'Verwijderen uit lijst' : 'Toevoegen aan lijst'}>
                    </sl-icon-button>
                    </sl-animation>
                    <span class="prices">${this.renderPrice()}</span>
                </div>
                <div class="product-item3">
                    <div class="product-name">
                      ${this.productSearchResult.product_name}
                    </div>
                 </div>            
                </div>
              </div>
            </div>
    `
  }

  private touchHandler(touchEvent: TouchEvent) {
    const target: HTMLElement = touchEvent.target as HTMLElement;
    const shopId: string = this.productSearchResult!.shop as string;
    const productRef: string = this.productSearchResult!.product_ref as string;
    if (target.id === 'favorite') {
      if (!this.favorite) {
        this.dispatchEvent(new AddToListEvent({
          shopId,
          productRef
        }));
      } else {
        this.dispatchEvent(new RemoveFromListEvent({
          shopId,
          productRef
        }));

      }
    } else {
      this.dispatchEvent(new NavigateEvent({ url: this.productSearchResult?.productUrl || "" }));
    }
  }

}
